import { EVENT_PAYLOAD } from '#pplx/frontend/framework/instrumentation/types.js';
const plusMenuOpenedEvent = {
    event: 'plus menu opened',
    data: {},
};
/** @returns Nothing; open transitions emit the existing Plus-menu event. */
export function trackPlusMenuOpenChange({ open, track, }) {
    if (open) {
        track(plusMenuOpenedEvent);
    }
}
export const addFilesFromCloudSubmenuOpenedEvent = {
    event: 'add files from cloud submenu opened',
    data: {},
};
export const connectorsAndSourcesSubmenuOpenedEvent = {
    event: 'connectors and sources submenu opened',
    data: {},
};
export const spacesSubmenuOpenedEvent = {
    event: 'spaces submenu opened',
    data: {},
};
export const skillsSubmenuOpenedEvent = {
    event: 'skills submenu opened',
    data: {},
};
export const PLUS_MENU_ITEM_SELECTED_EVENT_NAME = 'plus menu item selected';
export const plusMenuItemSelectedEvent = EVENT_PAYLOAD;
//# sourceMappingURL=analytics.js.map